<template>

	<div
		v-if="isVisible"
		class="cookie-notice"
	>

		<div class="cookie-notice__content">

			<div class="cookie-notice__text">

                <span class="cookie-notice__eyebrow">
                    {{ 'cookie_notice' | staticContentAlt }}
                </span>

                <h3>
                    {{ 'cookie_notice' | staticTitle }}
                </h3>

                <p>
                    {{ 'cookie_notice' | staticContent }}
                </p>


			</div>

			<div class="cookie-notice__actions">

				<router-link
					to="/cookies"
					class="cookie-notice__link"
				>
					{{ 'cookie_notice_actions' | staticTitle }}
				</router-link>

				<button
					type="button"
					class="cookie-notice__button"
					@click="closeNotice"
				>
					{{ 'cookie_notice_actions' | staticContent }}
				</button>

			</div>

		</div>

	</div>

</template>

<script>
import {localStorageGet, localStorageSet} from '@/utils';
export default {
    name: 'CookieNotice',

    props: {
        cookieReadedKeyName: {
            type: String,
            default: 'cookieNoticeClosedPIB2'
        }
    },

    data() {
        return {
            isVisible: false
        };
    },

    methods: {
        closeNotice() {
            this.isVisible = false;
            localStorageSet(this.cookieReadedKeyName, 'true');
        }
    },

    beforeMount() {
        this.isVisible = localStorageGet(this.cookieReadedKeyName) !== 'true';
    }
};
</script>

<style lang="scss" scoped>
.cookie-notice {
	position: fixed;

	left: 16px;
	right: 16px;
	bottom: 16px;

	z-index: 9999;

	padding: 20px;

	background: rgba(17, 24, 39, .98);

	border: 1px solid rgba(255, 255, 255, .12);
	border-radius: 16px;

	box-shadow: 0 18px 50px rgba(0, 0, 0, .35);

	backdrop-filter: blur(14px);
	-webkit-backdrop-filter: blur(14px);

	&__content {
		display: flex;
		flex-direction: column;

		gap: 20px;

		max-width: 1280px;

		margin: 0 auto;
	}

	&__text {

		h3 {
			margin: 0 0 8px;

			color: var(--white);

			font-size: 18px;
			line-height: 1.3;
		}

		p {
			margin: 0;

			color: var(--text-muted);

			font-size: 14px;
			line-height: 1.6;
		}
	}

	&__actions {
		display: flex;
		flex-direction: column;

		gap: 10px;
	}

	&__link,
	&__button {
		display: inline-flex;
		align-items: center;
		justify-content: center;

		min-height: 44px;

		padding: 0 20px;

		border-radius: 10px;

		font-size: 13px;
		font-weight: 700;
		letter-spacing: .5px;

		text-transform: uppercase;

		transition: var(--transition);

		cursor: pointer;
	}

	&__link {
		color: var(--white);

		border: 1px solid rgba(255, 255, 255, .25);

		text-decoration: none;

		&:hover {
			border-color: var(--primary);
			color: var(--primary);
		}
	}

	&__button {
		border: 1px solid var(--primary);

		background: var(--primary);
		color: var(--white);

		&:hover {
			background: var(--primary-hover);
			border-color: var(--primary-hover);
		}
	}
}

@media (min-width: 768px) {
	.cookie-notice {
		left: 24px;
		right: 24px;
		bottom: 24px;

		padding: 22px 26px;

		&__content {
			flex-direction: row;
			align-items: center;
			justify-content: space-between;

			gap: 30px;
		}

		&__text {
			max-width: 760px;
		}

		&__actions {
			flex-direction: row;
			flex-shrink: 0;
		}
	}
}
</style>